import { render, staticRenderFns } from "./user_wtfw.vue?vue&type=template&id=497554c8&scoped=true"
import script from "./user_wtfw.vue?vue&type=script&lang=js"
export * from "./user_wtfw.vue?vue&type=script&lang=js"
import style0 from "./user_wtfw.vue?vue&type=style&index=0&id=497554c8&prod&scoped=true&lang=less"
import style1 from "./user_wtfw.vue?vue&type=style&index=1&id=497554c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497554c8",
  null
  
)

export default component.exports